import { getOutboundRedirect } from "@/lib/api";
import { buildAffiliateUrl } from "@/lib/affiliateEngine";

// Section 2 — Centralized Outbound Redirect Interceptor. Every "Snag Deal"/card tap
// across Scroll/Discover/Daily Deck/Check resolves its real per-network affiliate tag
// (Amazon/CJ/Impact/Sovrn — see affiliateEngine.js) client-side and opens instantly,
// with zero backend round-trip blocking the click. Backend click-logging still fires
// afterwards in the background (fire-and-forget) purely for admin analytics/telemetry
// — its result is never awaited and can never delay or break the redirect itself.
export async function snagOutbound({ url, itemId = "", merchant = "", title = "", price = null }) {
  if (!url) return;
  const dest = buildAffiliateUrl(url, merchant);
  window.open(dest, "_blank", "noopener,noreferrer");
  getOutboundRedirect({ targetUrl: url, itemId, merchantName: merchant, itemTitle: title, price }).catch(() => { /* logging-only, never blocks the redirect */ });
}

function isIOSDevice() {
  try {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  } catch {
    return false;
  }
}

// Discover · MAP category location action — deep-links to the device's own native
// Maps app (Apple Maps on iOS, Google Maps everywhere else) for a local reseller/pickup
// result. Still routed through snagOutbound() for consistent click logging, but
// buildAffiliateUrl() explicitly never wraps maps:// or maps.google./maps.apple.
// destinations — there's no retail commission on a directions link.
export async function snagMapLocation({ title = "", address = "", lat = null, lng = null, itemId = "" }) {
  const hasCoords = lat != null && lng != null;
  const query = encodeURIComponent(address || title || "");
  const url = isIOSDevice()
    ? `maps://?q=${query}${hasCoords ? `&ll=${lat},${lng}` : ""}`
    : `https://maps.google.com/?q=${hasCoords ? `${lat},${lng}` : query}`;
  await snagOutbound({ url, itemId, merchant: title, title });
}
